import React, { useEffect } from "react";

import NavBarCustom from "../../components/NavBarCustom/NavBarCustom";
import Footer from "../../containers/Footer/Footer";
import Privacy from "../../containers/Privacy/Privacy";

import "../../App.css";

import "./PrivacyPage.css";

const PrivacyPage = (props) => {
	useEffect(() => {
		// Scroll to the top when the component mounts
		window.scrollTo(0, 0);
	}, []);

	return (
		<div className="privacy-page-container navbar-correction">
			<NavBarCustom />
			<Privacy />
			<Footer />
		</div>
	);
};

export default PrivacyPage;
